// extracted by mini-css-extract-plugin
module.exports = {"primaryColour":"#09CCC4","section":"index-module--section--2nAm5"};